import { defineStore } from 'pinia'
import type { PlacementResult } from './types'
import type { UserAnswer } from '@/views/placement/types'

export const usePlacementStore = defineStore('placement-store', {
  state: () => ({
    step: 0 as number,
    answers: [] as UserAnswer[],
    result: {} as PlacementResult
  }),
  getters: {
    getResult: (state) => state.result,
    getStep: (state) => state.step,
    getAnswers: (state) => state.answers
  },
  actions: {
    setStep() {
      this.step++
    },
    setResult(payload: PlacementResult) {
      this.result = payload
    },
    setAnswers(payload: UserAnswer) {
      this.answers.push(payload)
    },
    resetPlacement() {
      this.step = 0
      this.answers = []
    }
  },
  persist: true
})
